import React from 'react';
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry, themeQuartz } from 'ag-grid-community';
import "ag-grid-enterprise";
import SingleSelectWithSearch from "../../../components/dropdown/SingleSelectWithSearch";
import TextInput from "../../../components/UIComponent/TextInput";
import ModalBasic from "../../component/ModalBasic";

export const AddItemPopup = (props) => {
    return (
        <ModalBasic
            id="receive-receipt-details"
            classParams="!w-[65%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}>
            <>
                <div className="input-fields bg-white p-[30px] shadow-normalShadow rounded-[10px]">
                    <div className="item-grp">
                        <span className="text-blue text-[16px] font-semibold">Add New Item</span>
                        <div className="item-inner grid grid-cols-4 gap-2.5 mt-[5px]">
                            {/* <div className="input-grp">
                            <label>Ledger no</label>
                            <TextInput type="number" id="ledgerNo" name="ledgerNo" value={props.addItemObject.ledgerNo} handleChange={(event) => props.handleChange(event, "ledgerNo")} disabled />
                        </div>
                        <div className="input-grp">
                            <label>Date</label>
                            <TextInput type="date" id="date" name="date" value={props.addItemObject.date} handleChange={(event) => props.handleChange(event, "date")} className={props.validState?.error?.date !== undefined ? "error" : ""} />
                        </div> */}
                            <div className="input-grp col-span-2">
                                <label>Bank Ledger</label>
                                <SingleSelectWithSearch
                                    //id="type"
                                    //name="type"
                                    //value={props.types} 
                                    drpIdentity={"bankLedger"}
                                    optionArray={props.bankLedgerList}
                                    handleChangeTest={(event) => props.handleSelectChange(event, "bankLedger")}
                                    value={props.addItemObject.idExpenseType}
                                    setFilterParameters={props.setFilterParametersForAddItem}
                                    searchText={props.addItemObject.productName}
                                    classParams={props.validStateForAddItem?.error?.idExpenseType !== undefined ? "error" : ""}
                                />
                                {/* <TextInput
                                id="bankLedger"
                                name="bankLedger"
                                value={props.addItemObject.employeeName}
                                handleOnClick={(event) => props.handleOnClick(event, "bankLedger")}

                            /> */}
                                {/* <SingleSelectWithSearch id="authorizeBy" name="authorizeBy" value={props.addItemObject.authorizeBy} handleChangeTest={(event) => props.handleSelectChange(event, "authorizeBy")} className={props.validState?.error?.authorizeBy !== undefined ? "error" : ""} /> */}
                            </div>
                            <div className="input-grp col-span-2">
                                <label>Amount</label>
                                <TextInput
                                    id="amount"
                                    name="amount"
                                    type="number"
                                    value={props.addItemObject.amount}
                                    handleChange={(event) => props.handleSelectChange(event, "amount")}
                                // className={props.validState?.error?.amount !== undefined ? "error" : ""}
                                //disabled
                                />
                            </div>

                        </div>
                        <div className="item-inner grid grid-cols-4 gap-2.5 mt-2.5 mb-3">
                            <div className="input-grp col-span-2">
                                <label>Reference No</label>
                                <TextInput
                                    id="referenceNo"
                                    name="referenceNo"
                                    value={props.addItemObject.referenceNo}
                                    handleChange={(event) => props.handleSelectChange(event, "referenceNo")}
                                //disabled
                                />
                            </div>
                            <div className="input-grp col-span-2">
                                <label>Description</label>
                                <TextInput
                                    type="text"
                                    id="description"
                                    name="description"
                                    value={props.addItemObject.description}
                                    handleChange={(event) => props.handleSelectChange(event, "description")}
                                />
                            </div>
                        </div>
                        <div className='item-inner grid grid-cols-4 gap-2.5 pb-[10px] mb-[10px] border-b border-slate-200'>

                        </div>
                        <div className="btn-grp inline-flex gap-2.5">
                            {props.addItemObject.isUpdate === true ?
                                <button className="update-btn btns"
                                    onClick={() => props.updateNewItem()}
                                >
                                    Update Item
                                </button>
                                :
                                <button className="update-btn btns"
                                    onClick={() => props.addNewItem()}
                                >
                                    Add Item
                                </button>
                            }
                            <button className="delete-btn btns"
                                onClick={() => props.handleDeleteItem(props.addItemObject.keyId)}
                            >
                                Delete
                            </button>
                            {/* {props.addItemObject.keyId > 0 ?
                                :
                                null
                            } */}

                        </div>
                    </div>
                </div>
                {/* <AddItemPopup
                    isModalOpen={props.isAddItemPopup}
                    addItemObject={props.addItemObject}
                    bankLedgerList={props.bankLedgerList}
                    //colDefs={props.chequeBookSeriesColDefs}
                    //isModalOpen={props.isChequeBookSeriesPopUp}
                    setOpenModel={props.setOpenModel4}
                    addNewItem={props.addNewItem}
                    handleSelectChange={props.handleSelectChange}
                    setFilterParametersForAddItem={props.setFilterParametersForAddItem}
                //handleSelectChange={this.handlChequeBookSeriesCellClick}
                //receiptDetails={props.receiptDetails}handleSelectChange
                /> */}
            </>
        </ModalBasic>
    );
}